import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-479a9892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm glyphicon glyphicon-pencil" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "renaming-buttons" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "row nav-row" }
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = {
  class: "nav nav-pills tab-list",
  role: "tablist"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-8 content-column" }

import { computed, ref, onMounted } from "vue";
import axios from "axios";
import dayjs from "dayjs";
import { debug as d } from "debug";
import { useVuelidate } from "@vuelidate/core";
import { maxLength, required } from "@vuelidate/validators";
import TeamsOrGroups from "../../typings/enums/teams-or-groups";
import { setTitle } from "../../services/utilities/set-title";
import {
  CustomFrameworkForOrganisationsApiModel,
  GroupAndMembersApiModel,
  OrganisationAndMembersApiModel,
  OrganisationDescriptionApiModel,
  OrganisationMemberApiModel,
  OrganisationMemberApiRole,
  OrganisationMemberUpdateApiModel,
} from "../../api-models";
import OrganisationMemberMoveDialog from "../../components/admin/organisation/organisation-member-move-dialog.vue";
import OrganisationGroupAddDialog from "../../components/admin/organisation/organisation-group-add-dialog.vue";
import SettingsTab from "../../components/admin/organisation/settings-tab.vue";
import DataTab from "../../components/admin/organisation/data-tab.vue";
import GroupsTab from "../../components/admin/organisation/groups-tab.vue";
import TeamsTab from "../../components/admin/organisation/teams-tab.vue";
import MembersTab from "../../components/admin/organisation/members-tab.vue";
import LoadingPage from "../loading-page.vue";
import organisationNameRegex from "../../services/utilities/organisation-name-regex";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-page',
  props: {
    id: {}
  },
  setup(__props: any) {

const debug = d("cs.OrganisationPage");

function sortGroups(groups: GroupAndMembersApiModel[]): GroupAndMembersApiModel[] {
  return groups.slice().sort((a, b) => {
    if (a.group.name < b.group.name) {
      return -1;
    }
    if (a.group.name > b.group.name) {
      return 1;
    }

    return 0;
  });
}

const props = __props;

const model = ref<OrganisationAndMembersApiModel | null>(null);
const frameworkModel = ref<CustomFrameworkForOrganisationsApiModel | null>(null);
const visibleOrganisations = ref<OrganisationDescriptionApiModel[]>([]);
const isRenaming = ref(false);
const newName = ref("");
const saveInProgress = ref(false);
const appliedFilter = ref<string | null>(null);
const settingsUpdateIsLoading = ref(false);
const settingsUpdatedSuccess = ref<boolean | null>(null);
const memberMoveDialog = ref();
const groupAddDialog = ref();

const rules = {
  newName: {
    required,
    maxLength: maxLength(40),
    regex: (value) => organisationNameRegex.test(value),
  },
};

const state = {
  newName,
};

const v$ = useVuelidate(rules, state, { $autoDirty: true });

const dateCreated = computed(() => {
  return model.value ? dayjs(model.value.dateCreated).format("DD/MM/YYYY") : null;
});

const sortedTeams = computed(() => {
  return model.value ? sortGroups(model.value.teams) : [];
});

const sortedGroups = computed(() => {
  return model.value ? sortGroups(model.value.groups) : [];
});

async function loadModel() {
  debug("loadModel started");
  saveInProgress.value = true;
  visibleOrganisations.value = (await axios.get("/api/organisation")).data;
  model.value = (await axios.get(`/api/organisation/${props.id}`)).data;
  saveInProgress.value = false;
  setTitle(`Organisation: ${props.id}`);
  debug("loadModel finished");
}

async function loadCustomFrameworkSettings() {
  frameworkModel.value = (await axios.get(`/api/organisationframework/${props.id}`)).data;
}

onMounted(async () => {
  debug("Mounted");
  try {
    await loadModel();
    await loadCustomFrameworkSettings();
  } catch (e) {
    debug(e);
  }
});

async function saveSettings(updatedFrameworkModel: CustomFrameworkForOrganisationsApiModel) {
  try {
    settingsUpdateIsLoading.value = true;
    await axios.post(`/api/organisationframework/${props.id}`, updatedFrameworkModel, {
      headers: { "content-type": "application/json" },
    });

    settingsUpdatedSuccess.value = true;
  } catch (e) {
    debug(e);
    settingsUpdatedSuccess.value = false;
  } finally {
    settingsUpdateIsLoading.value = false;
  }
}

async function revalidateData() {
  try {
    await loadModel();
    await loadCustomFrameworkSettings();
  } catch (e) {
    debug(e);
  }
}

function startRenaming() {
  isRenaming.value = true;
  newName.value = model.value?.name || "";
}

function cancelRenaming() {
  isRenaming.value = false;
  saveInProgress.value = false;
}

function saveRenaming(): void {
  if (v$.value.$touch) {
    (v$.value.$touch as any)();
  } else {
    throw new Error("Vuelidate this.$v.$touch() unavailable");
  }

  if (v$.value.$invalid) {
    return;
  }

  saveInProgress.value = true;
  axios
    .post(`/api/organisation/${props.id}`, JSON.stringify(newName.value), {
      headers: { "content-type": "application/json" },
    })
    .then(() => {
      isRenaming.value = false;
      saveInProgress.value = false;
      loadModel();
    })
    .catch(() => {
      // eslint-disable-next-line no-alert
      alert("There was a problem renaming the organisation, please try again.");
      cancelRenaming();
    });
}

function changeRole(member: OrganisationMemberApiModel, newRole: OrganisationMemberApiRole) {
  if (member.role === newRole) {
    return;
  }

  saveInProgress.value = true;
  axios
    .post(
      "/api/organisationmember/",
      {
        userId: member.shortUserDetails.id,
        organisationId: props.id,
        role: newRole,
      } as OrganisationMemberUpdateApiModel,
      {
        headers: { "content-type": "application/json" },
      },
    )
    .then((resp) => {
      saveInProgress.value = false;
      member.role = newRole;
    })
    .catch((error) => {
      alert("There was a problem changing the role, please try again.");
      saveInProgress.value = false;
    });
}

function addGroups(teamsOrGroups: TeamsOrGroups) {
  (groupAddDialog.value as any)
    .open(model.value as OrganisationAndMembersApiModel, teamsOrGroups)
    .then((result) => {
      if (result) {
        loadModel();
      }
    })
    .finally(() => {
      (groupAddDialog.value as any)?.close();
    });
}

// TAB SYSTEM
const currentTab = ref("members");

function selectMembersTab() {
  appliedFilter.value = null;
  currentTab.value = "members";
}

return (_ctx: any,_cache: any) => {
  return (model.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["organisation-details", { updating: saveInProgress.value }])
      }, [
        _createVNode(OrganisationMemberMoveDialog, {
          ref_key: "memberMoveDialog",
          ref: memberMoveDialog
        }, null, 512),
        _createVNode(OrganisationGroupAddDialog, {
          ref_key: "groupAddDialog",
          ref: groupAddDialog
        }, null, 512),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, [
              (!isRenaming.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(model.value.name) + " ", 1),
                    _createElementVNode("a", {
                      onClick: startRenaming,
                      href: "javascript:void(0)",
                      "aria-label": "rename"
                    }, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (isRenaming.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["renaming-container", { 'has-error': _unref(v$).newName.$error }])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newName).value = $event)),
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).newName.$touch())),
                      maxlength: "40",
                      "aria-label": "new name"
                    }, null, 544), [
                      [_vModelText, newName.value]
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: saveRenaming,
                        disabled: _unref(v$).$error,
                        type: "button"
                      }, " Save ", 8, _hoisted_7),
                      _createElementVNode("button", {
                        class: "btn btn-default",
                        onClick: cancelRenaming,
                        type: "button"
                      }, "Cancel")
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("i", null, "created on " + _toDisplayString(dateCreated.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", {
                role: "presentation",
                class: _normalizeClass({ active: currentTab.value === 'members' })
              }, [
                _createElementVNode("a", {
                  href: "#",
                  role: "tab",
                  "data-test": "members-tab",
                  onClick: _withModifiers(selectMembersTab, ["prevent"])
                }, "Members (" + _toDisplayString(model.value.members.length) + ")", 1)
              ], 2),
              _createElementVNode("li", {
                role: "presentation",
                class: _normalizeClass({ active: currentTab.value === 'teams' })
              }, [
                _createElementVNode("a", {
                  href: "#",
                  role: "tab",
                  "data-test": "teams-tab",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (currentTab.value = 'teams'), ["prevent"]))
                }, "Teams (" + _toDisplayString(model.value.teams.length) + ")", 1)
              ], 2),
              _createElementVNode("li", {
                role: "presentation",
                class: _normalizeClass({ active: currentTab.value === 'groups' })
              }, [
                _createElementVNode("a", {
                  href: "#",
                  role: "tab",
                  "data-test": "org-groups-tab",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (currentTab.value = 'groups'), ["prevent"]))
                }, "Groups (" + _toDisplayString(model.value.groups.length) + ")", 1)
              ], 2),
              _createElementVNode("li", {
                role: "presentation",
                class: _normalizeClass({ active: currentTab.value === 'data' })
              }, [
                _createElementVNode("a", {
                  href: "#",
                  role: "tab",
                  "data-test": "org-data-tab",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (currentTab.value = 'data'), ["prevent"]))
                }, "Data")
              ], 2),
              _createElementVNode("li", {
                role: "presentation",
                class: _normalizeClass({ active: currentTab.value === 'settings' })
              }, [
                _createElementVNode("a", {
                  href: "#",
                  role: "tab",
                  "data-test": "org-settings-tab",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (currentTab.value = 'settings'), ["prevent"]))
                }, "Settings")
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createVNode(MembersTab, {
              model: model.value,
              onRevalidateOrgData: revalidateData
            }, null, 8, ["model"]), [
              [_vShow, currentTab.value === 'members']
            ]),
            _withDirectives(_createVNode(TeamsTab, {
              id: _ctx.id,
              model: model.value,
              teamsOrGroups: _unref(TeamsOrGroups),
              canCreateGroupsAndTeams: true,
              sortedTeams: sortedTeams.value,
              onAddGroups: addGroups
            }, null, 8, ["id", "model", "teamsOrGroups", "sortedTeams"]), [
              [_vShow, currentTab.value === 'teams']
            ]),
            _withDirectives(_createVNode(GroupsTab, {
              id: _ctx.id,
              model: model.value,
              teamsOrGroups: _unref(TeamsOrGroups),
              canCreateGroupsAndTeams: true,
              sortedGroups: sortedGroups.value,
              onAddGroups: addGroups
            }, null, 8, ["id", "model", "teamsOrGroups", "sortedGroups"]), [
              [_vShow, currentTab.value === 'groups']
            ]),
            _withDirectives(_createVNode(DataTab, {
              model: model.value,
              onRevalidateOrgData: revalidateData
            }, null, 8, ["model"]), [
              [_vShow, currentTab.value === 'data']
            ]),
            (currentTab.value === 'settings' && !!frameworkModel.value)
              ? (_openBlock(), _createBlock(SettingsTab, {
                  key: 0,
                  frameworkModel: frameworkModel.value,
                  settingsUpdateIsLoading: settingsUpdateIsLoading.value,
                  settingsUpdatedSuccess: settingsUpdatedSuccess.value ?? undefined,
                  onSaveSettings: saveSettings
                }, null, 8, ["frameworkModel", "settingsUpdateIsLoading", "settingsUpdatedSuccess"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})